import React, { useState } from 'react'
import { DialogBase, PrimaryCta, SecondaryCta } from 'components'
import { Button, Typography } from '@mui/material'
import { useUpdateStudentSpecialCaseMutation } from 'features/students/studentApiSlice'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features/snack-bar/snackSlice'

export default function SetStudentSpecialCaseDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    togglerProps = {},
    children,
    rowData = {},
  } = _props

  const [open, setOpen] = useState(false)
  const [force, setForce] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setForce(false)
    setIsSubmitting(false)
    setOpen(false)
  }

  const [updateStudentSpecialCase] = useUpdateStudentSpecialCaseMutation()

  const dni = rowData?.studentdni
  const studentid = rowData?.studentid
  const fullName = rowData?.firstname + ' ' + rowData?.lastname
  const isDisabled = 'i' === rowData?.state

  async function handleSubmit() {
    const handleApiError = (error) => {
      const toastErrorAndClose = () => {
        dispatch(
          errorSnack({
            message: `${fullName} - ${dni} no pudo ser marcado como caso especial.`,
          })
        )
        closeDialog()
      }

      if (force) {
        toastErrorAndClose()
      } else {
        if (
          error?.status === 409 &&
          error?.data?.message === 'student_has_account'
        ) {
          setForce(true) // Triggers next step for confirmation
        } else {
          toastErrorAndClose()
        }
      }
    }

    setIsSubmitting(true)
    try {
      const result = await updateStudentSpecialCase({
        studentid,
        force,
      })

      if (!result.error) {
        dispatch(
          successSnack({
            message: `${fullName} - ${dni} fué marcado como caso especial.`,
          })
        )
        closeDialog()
      } else {
        handleApiError(result.error)
      }
    } catch (e) {
      handleApiError(e)
    } finally {
      setIsSubmitting(false)
    }
  }

  const title = !force
    ? 'Marcar como caso especial'
    : 'Confirmar el caso especial'

  const message = !force
    ? `Desea marcar a ${fullName} - ${dni} como caso especial?`
    : `a ${fullName} - ${dni} ya cuenta con una billetera. Desea marcarlo como caso especial de todas formas?`

  return (
    <>
      <Component
        title="Marcar como caso especial"
        onClick={openDialog}
        {...togglerProps}
        disabled={isDisabled}
      >
        {children}
      </Component>
      {open && (
        <DialogBase
          title={title}
          titleAlignment="center"
          open={open}
          handleClose={closeDialog}
        >
          <Typography variant="h4" component="div">
            {message}
          </Typography>

          <div className="flex flex-row justify-center gap-4 w-full mt-10">
            <SecondaryCta onClick={closeDialog} disabled={isSubmitting}>
              Cerrar
            </SecondaryCta>
            <PrimaryCta onClick={handleSubmit} isSubmitting={isSubmitting}>
              Confirmar
            </PrimaryCta>
          </div>
        </DialogBase>
      )}
    </>
  )
}
